import React, { createContext, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGetStorage } from 'src/api/storage'
import { IStorage } from 'src/generated-types/storage-types'
import { axios } from '../axios'
import { CenteredSpinner } from '../components/Spinner'
import { FacilityNotFoundPage } from 'src/components/common/FacilityNotFoundPage'
import { useTranslation } from 'react-i18next'

interface StorageContextProps {
  selectedStorage: IStorage
  permission: number
}

export const CustomerStorageCtx = createContext<StorageContextProps>(null!)

export const StorageContextProvider: React.FC = ({ children }) => {
  const { customerId, storageId } = useParams()
  const {
    data,
    isLoading: selectedStorageLoading,
    error,
  } = useGetStorage(customerId as EntityId, storageId as EntityId)
  const { t } = useTranslation('storage')
  const [permission, setPermission] = useState<number>(-1)
  const selectedStorage = useMemo(() => data as IStorage, [data])

  useEffect(() => {
    if (data) {
      axios.defaults.headers['X-Permissions'] = data.encryptedPermission
      setPermission(data?.permission as number)
    }
  }, [data])

  const contextValue: StorageContextProps = {
    selectedStorage,
    permission,
  }

  if (selectedStorageLoading) return <CenteredSpinner />
  if (error && error['status'] == 404) return <FacilityNotFoundPage facility={t('storage', { ns: 'storage' })} />

  return <CustomerStorageCtx.Provider value={contextValue}>{permission != -1 && children}</CustomerStorageCtx.Provider>
}
